import { apiFetch } from './client';

export const lessonsApi = {
  list: async () => {
    const json = await apiFetch('/api/lessons');
    return json.lessons || json.data?.lessons || [];
  },

  get: async (code) => {
    const json = await apiFetch(`/api/lessons/${encodeURIComponent(code)}`);
    return json.lesson || json.data?.lesson || json;
  },

  create: async (lesson) => {
    const json = await apiFetch('/api/lessons', {
      method: 'POST',
      body: JSON.stringify(lesson),
    });
    return json.lesson || json.data?.lesson || json;
  },

  update: async (id, fields) => {
    const json = await apiFetch(`/api/lessons/${id}`, {
      method: 'PUT',
      body: JSON.stringify(fields),
    });
    return json.lesson || json.data?.lesson || json;
  },

  remove: async (id) => apiFetch(`/api/lessons/${id}`, { method: 'DELETE' }),

  updateDialogue: async (id, fields) => {
    const json = await apiFetch(`/api/lesson-dialogues/${id}`, {
      method: 'PUT',
      body: JSON.stringify(fields),
    });
    return json.dialogue || json.data?.dialogue || json;
  },

  updateCharacter: async (id, fields) => {
    // Translate the legacy `radical_meaning` shape if present
    const body = { ...fields };
    if (body.radical_meaning !== undefined && body.radicalMeaning === undefined) {
      body.radicalMeaning = body.radical_meaning;
      delete body.radical_meaning;
    }
    const json = await apiFetch(`/api/lesson-characters/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    });
    return json.character || json.data?.character || json;
  },
};
